//APP
import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";

//Layout prioritario inicial (Above The Fold)
import Header from "./layout/Header";
import NavbarMenu from "./layout/NavbarMenu";
import ScrollToTop from "./layout/ScrollToTop/ScrollToTop";
import AppRoutes from "./routes";
import LazySection from "./components/LazySection";

// Footer diferido por scroll (Below The Fold)
const Footer = lazy(() => import("./layout/Footer"));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="hdr-op4-app-header-group">
        <Header></Header>
        <NavbarMenu></NavbarMenu>
      </div>
      <div className="mt-3 App__container">
        <AppRoutes />
      </div>
      <LazySection id="pie-de-pagina" minHeight="450px" marginBlock="3.5rem 0">
        <Suspense fallback={<div style={{ minHeight: "450px" }} />}>
          <Footer />
        </Suspense>
      </LazySection>
    </Router>
  );
}

export default App;
